import { render, staticRenderFns } from "./magnetismDetailDialog.vue?vue&type=template&id=562ce50a&"
import script from "./magnetismDetailDialog.vue?vue&type=script&lang=js&"
export * from "./magnetismDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports